export function getCookie(key: string) {
  return document.cookie
    .split(";")
    .map((keyValue) => keyValue.split("=").map((x) => x.trim()))
    .find((keyValue) => keyValue[0] === key)?.[1];
}
